parasails.registerPage('mclogin', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    overallEventID: '',
    syncing: false,
    // Form data
    formData: {
      rememberMe: true,
      accountRole: 'member'
    },
    // For tracking client-side validation errors in our form.
    // > Has property set to `true` for each invalid property in `formData`.
    formErrors: { /* … */ },
    // A set of validation rules for our form.
    // > The form will not be submitted if these are invalid.
    formRules: {
      emailAddress: { required: true, isEmail: true },
      password: { required: true },
    },
    // Server error state for the form
    cloudError: '',
    showPassword: false,
    loginMessage: '電子チケットに登録のメールアドレスを入力してください',
    eventLogo: 'images/caramel-logo.png',
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    const urlParams = new URLSearchParams(window.location.search);
    this.eventID = urlParams.get('eventID');
    this.formData.eventID = this.eventID;
    this.setLogo();
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    setLogo() {
      // if(this.eventData !== null) {
      //   if(this.eventData.logoImage) {
      //     this.eventLogo = this.eventData.logoImage;
      //   }
      //   if(this.eventData.subLogoImage) {
      //     this.subLogo = this.eventData.subLogoImage;
      //   }
      // }
    },
    submittedForm: async function() {
      // Redirect to the logged-in dashboard on success.
      // > (Note that we re-enable the syncing state here.  This is on purpose--
      // > to make sure the spinner stays there until the page navigation finishes.)
      this.syncing = true;
      window.location = '/spotlightmanager?eventID=' + this.eventID;
    },
  }
});
